export default __webpack_public_path__ + "static/media/moota.306d4483.svg";